import FilterAlt from "@mui/icons-material/FilterAlt";
import FilterAltOutlined from "@mui/icons-material/FilterAltOutlined";
import { IconButton, Tooltip } from "@mui/material";
import type { Ref } from "react";

export type DataGridFilterControlProps = {
	hasActiveFilter: boolean;
	onOpenFilterPanel: () => void;
	buttonRef?: Ref<HTMLButtonElement>;
};

export default function DataGridFilterControl(props: DataGridFilterControlProps) {
	const { hasActiveFilter, onOpenFilterPanel, buttonRef } = props;

	return (
		<Tooltip title={hasActiveFilter ? "Filters applied — edit" : "Filter"}>
			<IconButton
				ref={buttonRef}
				aria-label={hasActiveFilter ? "Edit filters (filters applied)" : "Filter"}
				onClick={onOpenFilterPanel}
				size="small"
				sx={{
					borderRadius: "8px",
					border: hasActiveFilter ? "1px solid rgba(2, 213, 171, 0.40)" : "1px solid rgba(13, 31, 48, 0.12)",
					background: hasActiveFilter ? "rgba(2, 213, 171, 0.12)" : "#FFFFFF",
					color: hasActiveFilter ? "#02B894" : "rgba(13, 31, 48, 0.55)",
					transition: "background 0.15s, border-color 0.15s, color 0.15s",
					"&:hover": { background: "rgba(2, 213, 171, 0.10)", borderColor: "rgba(2, 213, 171, 0.35)", color: "#02B894" },
				}}
			>
				{hasActiveFilter ? <FilterAlt sx={{ fontSize: 18 }} /> : <FilterAltOutlined sx={{ fontSize: 18 }} />}
			</IconButton>
		</Tooltip>
	);
}
